import { ReactNode } from 'react';

import { useAlert } from '@inbody/core';
import { MutationCache, QueryCache } from '@tanstack/react-query';

import { useErrorTranslation } from '../i18n/hooks';
import { QueryProvider } from './QueryProvider';

type CustomQueryProviderProps = {
  children: ReactNode;
};

export const CustomQueryProvider = ({ children }: CustomQueryProviderProps) => {
  const { t: errorsT } = useErrorTranslation();
  const { toastAlert } = useAlert();
  return (
    <QueryProvider
      options={{
        queryCache: new QueryCache({
          onError: async (err: any) => {
            if (err?.response) {
              const errorData = await err.response.json();
              if (errorData?.messageKey) {
                toastAlert.error(errorsT(errorData.messageKey));
              }
            }
          },
        }),
        mutationCache: new MutationCache({
          onError: async (err: any) => {
            if (err?.response) {
              const errorData = await err.response.json();
              if (errorData?.messageKey) {
                toastAlert.error(errorsT(errorData.messageKey));
              }
            }
          },
        }),
      }}
    >
      {children}
    </QueryProvider>
  );
};
